import { useState, useEffect, useContext } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

import { Container, Modal } from '@components';
import { checkEnabled, checkValue } from '@components/OptionalFeature';
import PageContext from '@contexts/PageContext';
import { isMobile } from '@helpers/breakpoints';
import { getBackupImg } from '@helpers/dataExists';

import Fullscreen from '@assets/icon/fullscreen-selected.svg';
import styles from './Features.module.scss';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), {
  ssr: false
});

const Features = ({ data, title, id, componentIsAvailable, showTitle, componentTitle }) => {
  const isMobileOpen = isMobile();
  const router = useRouter();
  const { locale } = router;
  const pageData = useContext(PageContext);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});

  /*Note: change true to false for checking component Dynamically*/
  const [showOnFrench, setShowOnFrench] = useState(true);
  const productCode = pageData.ProductCode;

  useEffect(() => {
    //check componnet enabled in french/english
    const DisplayValue = data?.DisplayOptions?.find((x) => x.DisplayOptionKey == 'DisplayComponent').OptionInformation;
    if (DisplayValue === true) {
      if (locale == 'fr') {
        setShowOnFrench(true);
      } else {
        setShowOnFrench(true);
      }
    } else {
      if (locale == 'fr') {
        /*Note: change true to false for checking component Dynamically*/
        setShowOnFrench(true);
      } else {
        setShowOnFrench(true);
      }
    }
  }, []);

  //Feature with Status 0 should not be shown
  const featuresToShow = pageData.Features.filter((feature) => feature.Status != 0);

  //show Feature Text
  const showFeatureText = checkEnabled(data?.DisplayOptions, 'FeatureText');

  //The section title on the page
  const sectionTitle = checkValue(data?.DisplayOptions, 'ComponentHeaderTitleText', locale);

  //check title of features are Enabled
  const eachFeatureTitleAvailable = checkEnabled(data?.DisplayOptions, 'Title');

  const openModel = (type, id, link) => {
    // find media
    if (['I', 'V'].includes(type)) {
      const selectedFeature = featuresToShow.find((item) => item.Id == id);
      setModalData(selectedFeature);
      setShowModal(true);
    } else {
      window.location.href = link;
      return;
    }
  };

  useEffect(async () => {
    await getBackupImg();
  });

  return (
    <section className={styles.Section} id={id}>
      {componentIsAvailable && showOnFrench && (
        <Container className={styles.Container}>
          {showTitle && <h2 className={styles.Title}>{sectionTitle ? sectionTitle : title}</h2>}
          <div className={styles.List}>
            {featuresToShow?.map((feature, index) => {
              const mappedImage = (
                <DynamicImage
                  imgSrc={`/api/static/media/byFile/products/${
                    feature.InheritProductCode ? feature.InheritProductCode : productCode
                  }/feature/${feature.FeatureNumber}_N_N_N_I_640X360.jpg`}
                  sizes={'640x360'}
                />
              );

              return feature ? (
                <div
                  className={styles.Item}
                  onClick={() => openModel(feature?.FeatureText?.ImageType, feature.Id, feature?.FeatureText?.Destination)}
                  key={index}
                >
                  {feature?.FeatureText?.ImageType == 'I' ? (
                    <div className={styles.ImageBox}>
                      {mappedImage}
                      <Fullscreen />
                    </div>
                  ) : feature?.FeatureText?.ImageType == 'V' ? (
                    <div className={styles.VideoBox}>
                      {mappedImage}
                      <FontAwesomeIcon icon={faPlay} />
                    </div>
                  ) : (
                    //If it is file
                    <div className={styles.ImageBox}>
                      {mappedImage}
                      <Fullscreen />
                    </div>
                  )}
                  {eachFeatureTitleAvailable && <h4 className={styles.Name}>{feature?.FeatureText?.Title}</h4>}
                  <div className={styles.Text}>
                    <p>{showFeatureText ? feature?.FeatureText?.FeatureText : null}</p>
                  </div>
                </div>
              ) : null;
            })}
          </div>
          <Modal
            data={modalData}
            show={showModal}
            onHide={() => setShowModal(false)}
            type="LightBox"
            solidBg={isMobileOpen ? "false" : "true"}
            player="true"
            sourceComponent="Feature"
            displayFeatureText={showFeatureText}
            productCode={productCode}
            ParentData={featuresToShow}
            title={modalData.FeatureText?.Title}
          />
        </Container>
      )}
    </section>
  );
};

export default Features;
